import Konva from "konva";
import { SC_Input } from "../input/SC_Input";
import { MountingSystem } from '../mountsys/MountingSystem';
import { MountingType } from '../mountsys/MountingType';
import { DrawRoofForPanel } from '../panel/drawRoofForPanel';
import { ModGroup } from '../panel/ModGroup';
import { ModList } from '../panel/ModList';
import { Modul } from '../panel/Modul';
import { AreaFinder } from "../roof/areaFinder";
import { RoofShape } from '../roof/RoofShape';
import { RoofType } from '../roof/RoofType';
import { Global } from '../utilities/global';
import { Statics } from '../utilities/statics';

// Returns stage object by using Konva
export function getCanvasStage(obj: any): Konva.Stage {
    return new Konva.Stage({ ...obj });
}

// Returns layer object by using Konva
export function getCanvasLayer(): Konva.Layer {
    return new Konva.Layer();
}

export function getCanvasLine(obj: any): Konva.Line {
    return new Konva.Line({ ...obj });
}

export function getCanvasText(obj: any): Konva.Text {
    return new Konva.Text({ ...obj });
}

export function getCanvasRect(obj: any): Konva.Rect {
    return new Konva.Rect({ ...obj });
}

export function getCanvasGroup(obj: any): Konva.Group {
    return new Konva.Group({
        draggable: true,
        ...obj
    });
}

// To draw Panel Images on roof.
// It will take input x, y starting postion and width and height of pannel
export function getCanvasImage(x: number, y: number, width: number, height: number, layer: any, angle: any, id: any) {

    var imageObj = new Image();
    var panelmg;
    imageObj.onload = function () {
        panelmg = new Konva.Image({
            image: imageObj,
            width: width,
            height: height,
            draggable: false,
            stroke: "#00ff89",
            strokeWidth: 0,
            x: 0,
            y: 0
        });
        var haveIntersection = (r1: any, r2: any) => {
            return !(
                r2.x > r1.x + r1.width ||
                r2.x + r2.width < r1.x ||
                r2.y > r1.y + r1.height ||
                r2.y + r2.height < r1.y
            );
        }
        var lastPos: any;
        var group = new Konva.Group({
            draggable: false,
            x: x,
            y: y,
            width: width,
            height: height,
            name:  Global.panelsOnRoof,
            id: id,
            dragBoundFunc: function (pos) {
                if (DrawRoofForPanel.stage.x() == 0 && DrawRoofForPanel.stage.y() == 0) {
                    let overlapping = false;
                    const start = 100 * DrawRoofForPanel.currentScale;
                    let obj = { x: 0, y: 0 }
                    let w = RoofShape.getCurrentRoofWidth() * DrawRoofForPanel.currentScale + start;
                    let h = RoofShape.getCurrentRoofHeight() * DrawRoofForPanel.currentScale + start;
                    const panelW = group.width() * DrawRoofForPanel.currentScale;
                    const panelH = group.height() * DrawRoofForPanel.currentScale;

                    if (pos.x < (start) || pos.y < (start)) {
                        if (pos.x < (start)) {
                            obj.x = start;
                            if (obj.y == 0) obj.y = pos.y;
                        }
                        if (pos.y < (start)) {
                            if (obj.x == 0) obj.x = pos.x
                            obj.y = start;
                        }
                        return obj;
                    } else
                        if ((pos.x + panelW) > (w) || (pos.y + panelH) > (h)) {
                            if ((pos.x + panelW) > (w)) {
                                obj.x = w - panelW;
                                if (obj.y == 0) obj.y = pos.y;
                            }
                            if ((pos.y + panelH) > (h)) {
                                if (obj.x == 0) obj.x = pos.x
                                obj.y = h - panelH;
                            }
                            return obj;
                        }

                    const allPanels: any = DrawRoofForPanel.layerPanel.find("." + Global.panelsOnRoof);
                    allPanels.forEach((item: any) => {
                        if (item.getAttrs().id != id) {
                            if (haveIntersection(item.getClientRect(), group.getClientRect())) {
                                overlapping = true;
                            }
                        }
                    });
                    const nonUsableArea: any = DrawRoofForPanel.layerPanel.find("." + Global.nonUsableArea);
                    if (nonUsableArea && nonUsableArea.length > 0) {
                        nonUsableArea.forEach((item: any) => {
                            if (haveIntersection(item.getClientRect(), group.getClientRect())) {
                                overlapping = true;
                                // const non = item.getClientRect();
                                // const panel = group.getClientRect();
                                // if (non.x > panel.x) {
                                //     lastPos = pos;
                                //     lastPos.x = non.x - 0.7 - panel.width;
                                //     return lastPos
                                // } else
                                //     if ((non.x + non.width) < panel.x) {
                                //         lastPos = pos;
                                //         lastPos.x = non.x + non.width + 0.7;
                                //         return lastPos
                                //     } else if ((non.y) > panel.x) {
                                //         lastPos = pos;
                                //         lastPos.y = non.y - panel.height - 0.7;
                                //         return lastPos
                                //     } else if ((non.y + non.height) < panel.x) {
                                //         lastPos = pos;
                                //         lastPos.y = non.y + non.height + 0.7;
                                //         return lastPos
                                //     }
                            }
                        });
                    }
                    if (overlapping && lastPos) return pos;
                    lastPos = pos;
                }
                return pos
            }
        });

        // group.rotate(angle);
        Modul.bindEventsForModule(group);
        var border1 = getCanvasLine({
            points: [1, 1, width - 1, 1, width - 1, height - 1, 1, height - 1, 1, 1],
            stroke: '#00ff89',
            strokeWidth: 2,
            opacity: 0,
            name: 'border1'
        });
        var border = getCanvasLine({
            points: [4, 4, width - 4, 4, width - 4, height - 4, 4, height - 4, 4, 4],
            stroke: '#00ff89',
            strokeWidth: 4,
            opacity: 0,
            name: 'border'
        });
        const sRange = !Global.toggleBoundaryArea ? AreaFinder.getAreaByModule(group.getAttrs()) : "h";
        let invalid_panel_status: boolean = false;
        if (SC_Input.iMountSys != MountingSystem.SOL50_PREM_IN) {
            if (Statics.oSpanWidthMax && Statics.oSpanWidthMax[sRange]) {
                if (Statics.oSpanWidthMax[sRange][width.toString()] == -1) {
                    invalid_panel_status = true;
                }
            } else {
                invalid_panel_status = true;
            }
        }
        if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL && SC_Input.iMountingType == MountingType.DIRECT) {
            invalid_panel_status = false;
        }
        group.add(panelmg);
        group.add(border1);
        group.add(border);
        group.add(colCanTilEver(width, height));
        group.add(leftInvalidPanels(width, height, invalid_panel_status));
        group.add(rightInvalidPanels(width, height, invalid_panel_status));

        // 
        layer.add(group);
        if (group) group.draw();
    };
    imageObj.src = document.baseURI + '/assets/images/mono.jpg';
    // imageObj.src = document.baseURI + '/assets/images/panel_sample.png';
}

export function getPanelForStings(x: number, y: number, width: number, height: number, layer: any) {

    const imageObj = new Image();
    imageObj.onload = function () {
       const panelmg = new Konva.Image({
            image: imageObj,
            width: width,
            height: height,
            x: x,
            y: y,
            name: "panelStrings"
        });        
        layer.add(panelmg);
        if (panelmg) panelmg.draw();
    };
    imageObj.src = document.baseURI + '/assets/images/mono.jpg';
}

function colCanTilEver(w: number, h: number) {
    return new Konva.Line({
        points: [
            0.25 * w,
            0.25 * h,
            0.75 * w,
            0.75 * h
        ],
        stroke: Global.colCanTilEver,
        strokeWidth: 4,
        name: 'canTilEver',
        opacity: 0
    });
}

function leftInvalidPanels(w: number, h: number, invalid_panel_status: boolean) {
    return new Konva.Line({
        points: [
            0.25 * w,
            0.25 * h,
            0.75 * w,
            0.75 * h
        ],
        stroke: Global.colInvalidPanels,
        strokeWidth: 4,
        name: 'invalidPanels',
        opacity: invalid_panel_status ? 1 : 0
    });
}

function rightInvalidPanels(w: number, h: number, invalid_panel_status: boolean) {
    return new Konva.Line({
        points: [
            0.75 * w,
            0.25 * h,
            0.25 * w,
            0.75 * h,
        ],
        stroke: Global.colInvalidPanels,
        strokeWidth: 4,
        name: 'invalidPanels',
        opacity: invalid_panel_status ? 1 : 0
    });
}